<template>
  <div class="flex flex-row flex-nowrap overflow-x-auto gap-2" v-bind="$attrs">
    <!-- Profile avatar skeleton (shown conditionally like original) -->
    <div v-if="showProfileAvatar" class="shrink-0">
      <div
        class="p-5u ring-inset ring-brand-primary ring-[3px] border-[4px] border-brand-quaternary-40 rounded-full flex"
      >
        <Skeleton width="32px" height="32px" border-radius="50%" />
      </div>
    </div>

    <!-- Plus button skeleton -->
    <div v-if="showPlusButton" class="shrink-0">
      <div
        class="rounded-full size-50u p-0 bg-brand-bgdivider-20 flex items-center justify-center relative"
      >
        <div
          class="flex-1 h-full items-center justify-center flex rounded-full transition-all duration-200 relative"
        >
          <Skeleton width="40px" height="40px" border-radius="50%" />
        </div>
      </div>
    </div>

    <!-- Channel avatar skeleton -->
    <div class="shrink-0">
      <div
        class="rounded-full size-50u p-0 bg-fill-brand-secondary flex items-center justify-center relative"
      >
        <div
          class="flex-1 h-full items-center justify-center flex rounded-full transition-all duration-200 relative ring-inset ring-fill-brand ring-4"
        >
          <Skeleton width="40px" height="40px" border-radius="50%" />
        </div>
      </div>
    </div>

    <!-- Community avatars skeletons -->
    <div v-for="avatarIndex in count" :key="avatarIndex" class="shrink-0">
      <div
        class="rounded-full size-50u p-0 bg-fill-brand-secondary flex items-center justify-center"
      >
        <div
          class="flex-1 h-full items-center justify-center flex rounded-full transition-all duration-200 relative"
        >
          <Skeleton width="40px" height="40px" border-radius="50%" />
        </div>
      </div>
    </div>

    <!-- Fallback text skeleton (when no communities) -->
    <div v-if="count === 0" class="self-center">
      <Skeleton width="180px" height="16px" border-radius="4px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";

withDefaults(
  defineProps<{
    count?: number;
    showProfileAvatar?: boolean;
    showPlusButton?: boolean;
    index?: number;
  }>(),
  {
    count: 4,
    showProfileAvatar: true,
    showPlusButton: false,
    index: 0,
  },
);
</script>
